/**
 * @fileoverview GET handler for the "/analytics_dashboard/:app_group_id/decisioning_studio_agents_credit_consumption_detail_data" endpoint
 */
import { isDecisioningStudioAgentsConsumptionResult } from "@dashboardApi/apis/decisioningStudioAgentsConsumption/validators";

import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { decisioningStudioAgentsConsumption } from "./constants";
import type { DecisioningStudioAgentsConsumptionParams, DecisioningStudioAgentsConsumptionResult } from "./types";

export const getDataTableDecisioningStudioAgentsConsumption = reactQueryTableFetcherAdapter(
  decisioningStudioAgentsConsumption,
  (
    signal: AbortSignal,
    {
      appGroupId,
      query = {},
      groupby,
      limit = 20,
      start = 0,
      sortdir,
      sortby,
    }: DecisioningStudioAgentsConsumptionParams
  ): Promise<DecisioningStudioAgentsConsumptionResult> => {
    // appGroupId is the current workspace's id from the route; app_group is a column filter on workspace name
    const { start_date, end_date, app_group: appGroup, agent_name: agentName } = query;

    return fetch(
      `/analytics_dashboard/${appGroupId}/decisioning_studio_agents_credit_consumption_detail_data`,
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        start_date: start_date,
        end_date: end_date,
        query: serializeQueryObjects({
          ...(appGroup && { app_group: appGroup }),
          ...(agentName && { agent_name: agentName }),
        }),
      },
      { signal }
    );
  },
  isDecisioningStudioAgentsConsumptionResult
);
